import React, { useMemo } from 'react';
import { TextMessage } from '@/components/chat/Message/TextMessage/TextMessage';
import { type LinkMessageMessageObject } from '@/types/message.types';
import { type LinkMessageProps } from './types';

export const LinkMessage = React.memo<LinkMessageProps>(({ message }) => {
  const link = useMemo(
    () =>
      (
        message?.extendedMessagePayload?.extendedMessagePayloadDetail
          ?.liveChatV2MessageObject as LinkMessageMessageObject
      )?.link_message,
    [message?.extendedMessagePayload?.extendedMessagePayloadDetail],
  );
  const { url, title, description, image_url } = link || {};

  return (
    <>
      <TextMessage message={message} />

      <div className="sf:message-bubble sf:bg-white/60 sf:rounded-xl sf:p-2 sf:w-[var(--w-message-bubble)] sf:shadow-message-bubble">
        <div className="sf:bg-white sf:rounded-lg sf:p-2 sf:w-full sf:shadow-message-bubble sf:flex sf:flex-row sf:items-start sf:gap-4">
          <div className="sf:flex-shrink-0 sf:bg-gray-20 sf:w-16 sf:h-16 sf:rounded-lg sf:flex sf:items-center sf:justify-center">
            <img
              src={image_url}
              alt={title}
              className="sf:w-full sf:h-full sf:object-cover sf:rounded-lg"
            />
          </div>

          <div>
            <p className="sf:text-sm sf:font-semibold sf:text-gray-900 sf:line-clamp-3">
              {title}
            </p>

            {description && (
              <p className="sf:text-xs sf:text-content-secondary sf:mt-1 sf:line-clamp-3">
                {description}
              </p>
            )}
          </div>
        </div>
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="sf:block sf:text-xs sf:mt-2 sf:text-widget-button-color sf:hover:underline sf:rounded sf:truncate sf:cursor-pointer"
        >
          {url}
        </a>
      </div>
    </>
  );
});

LinkMessage.displayName = 'LinkMessage';
